<template>
    <div>
        <b-form-group
            :label="label"
            :label-for="labelFor"
            class="secondary-label sl-helper">

            <template v-if="index !== 0">

                <b-input-group class="mt-3">
                    <b-input-group-text slot="append" class="bg-transparent border-0">
                        <button class="btn btn-ghost btn-delete shadow-none"
                            @click="deleteItem({
                                index: index,
                                uuid: question_uuid ? question_uuid : null
                            })">
                        </button>
                    </b-input-group-text>
                    <b-form-input
                        class="rounded-right"
                        v-model="question"
                        maxlength="25"
                        :aria-labelledby="['input-live-help invalid_' + index]"
                        :state="isValid('questions.' + index + '.question')">
                    </b-form-input>
                </b-input-group>
                <template v-if="isValid('questions.' + index + '.question') === false">
                    <b-form-invalid-feedback :id="'invalid_' + index" class="d-block">
                        {{ errorMessage('questions.' + index + '.question') }}
                    </b-form-invalid-feedback>
                </template>

            </template>

            <template v-else>
                <b-form-input
                    v-model="question"
                    maxlength="25"
                    :aria-labelledby="['input-live-help invalid_' + index]"
                    :state="isValid('questions.' + index + '.question')">
                </b-form-input>
                <b-form-invalid-feedback :id="'invalid_' + index">
                    {{ errorMessage('questions.' + index + '.question') }}
                </b-form-invalid-feedback>
            </template>

            <b-form-checkbox-group
                id="questionOpt"
                class="mt-3"
                :name="'questionOpt' + index"
                v-model="selectedOpt"
                stacked>
                <b-form-checkbox value="ratings">Ratings</b-form-checkbox>
                <b-form-checkbox value="textfield">Textfield</b-form-checkbox>
            </b-form-checkbox-group>
            <template
                v-if="isValid('questions.' + index + '.has_ratings') === false &&
                isValid('questions.' + index + '.has_textfield') === false">
                <b-form-invalid-feedback :id="'invalid_type_' + index" class="d-block">
                    Please select question type.
                </b-form-invalid-feedback>
            </template>
         </b-form-group>
        <hr class="form-divider my-3">
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "SurveyQuestion",
    props: ["label", "labelFor", "model", "index", "selected", "uuid"],
    data() {
        return {
            question: this.model,
            selectedOpt: this.selected,
            question_uuid: this.uuid
        };
    },
    computed: {
        ...mapState("engagementSurvey", ["errors"])
    },
    methods: {
        setPayload: function() {
            let payload = {
                question: this.question,
                index: this.index,
                selected: this.selectedOpt,
                uuid: this.question_uuid ? this.question_uuid : null
            };
            this.$emit("saveModel", payload);
        },

        deleteItem: async function(question) {
            await this.$emit("deleteModel", question);
        },

        errorMessage(field) {
            if (this.errors == null) {
                return "";
            }

            return this.errors[field];
        },

        isValid(field) {
            if (this.errors == null) {
                return null;
            }

            return this.errors[field] ? false : null;
        }
    },
    watch: {
        model: async function(value) {
            this.question = value;
        },

        selected: async function(value) {
            this.selectedOpt = value === undefined ? [] : value;
        },

        uuid: async function(value) {
            this.question_uuid = value;
        },

        question: async function() {
            await this.setPayload();
        },

        selectedOpt: async function() {
            await this.setPayload();
        },

        question_uuid: async function() {
            await this.setPayload();
        }
    }
}
</script>
